import { DESKTOP_WIDTH, useMediaQuery } from 'shared/hooks/useMediaQuery'

import { WIDGET_MARKETPLACE_WINDOW_ID } from '../components/WidgetMarketplace/WidgetMarketplace.constants'
import { useWindowStore } from '../stores'

export const useIsWindowMarketplaceOpen = () => {
  const windows = useWindowStore(state => state.windows)
  const widgetMarketplaceWindow = windows.find(
    w => w.id === WIDGET_MARKETPLACE_WINDOW_ID
  )

  const { width: screenWidth } = useMediaQuery()

  // above breakpoint: only show when window is visible
  // at or below breakpoint: show when window exists (minimized or visible)
  const isWidgetMarketplaceOpen =
    screenWidth > DESKTOP_WIDTH
      ? (widgetMarketplaceWindow?.isVisible ?? false)
      : !!widgetMarketplaceWindow

  return isWidgetMarketplaceOpen
}
